import React from "react";
import { Typography, Form, Button, Steps } from "antd";
import { CheckOutlined, CheckCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import FooterRegistraion from "../common/FooterDashboard/FooterRegistraion";
const { Title } = Typography;
const SuccessVerification = (props) => {
  let navigate = useNavigate();

  // Get User Email
  const userEmail = localStorage.getItem("userEmail");

  const handleSubmit = (data) => {
    return navigate("/");
  };

  // Registration  Steps
  const items = [
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 1</p>
            <h4>
              <b>Induction</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 2</p>
            <h4>
              <b>MCQ Test</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 3</p>
            <h4>
              <b>Protective Clothing</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 4</p>
            <h4>
              <b>Health Questionnaire</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 5</p>
            <h4>
              <b>Registraion</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
  ];

  const customDot = (dot, { status }) => {
    switch (status) {
      case "finish":
        return <CheckCircleFilled />;
      case "process":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      case "wait":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      default:
        return dot;
    }
  };

  return (
    <>
      <div
        className="logo-title"
        style={{ boxShadow: "3px 3px 10px -4px rgba(0, 0, 0, 0.1)" }}
      >
        <img
          src="/assest/Images/Logo/logo.png"
          className="logo-png"
          style={{ width: "14%" }}
        />
      </div>
      <div className="container form-container pt-3">
        <div className="row justify-content-center ">
          <div className="col-xl-10 col-lg-10 col-md-12 px-0">
            <Steps
              current={4}
              labelPlacement="vertical"
              items={items}
              progressDot={customDot}
            />
          </div>
          <Title className="sub-title text-center pt-5">
            Please verify your email
          </Title>
          <div className="col-xl-9 col-lg-9 col-md-12 p-0 pb-5">
            <div className="card-body ">
              <div className="question-border ">
                <Form
                  name="nest-messages"
                  layout="vertical"
                  onFinish={handleSubmit}
                >
                  <>
                    <div className="warning-alert alert-success d-flex mt-3">
                      <CheckOutlined className="success-icon" />
                      <div className="warning-content alert-success">
                        <h5>Email verification successfully sent!</h5>
                        <p>
                          Please check your mail <u>{userEmail}</u>.
                        </p>
                      </div>
                    </div>

                    {/* <div className="d-flex justify-content-center">
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn btn-primary btn-submit"
                      >
                        Login
                      </Button>
                    </div> */}
                  </>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <FooterRegistraion />
      </div>
    </>
  );
};

export default SuccessVerification;
